import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import(
                './discovery-standalone/discovery-standalone.component'
            ).then((m) => m.DiscoveryStandaloneComponent),
        children: [
            {
                path: 'researchers',
                loadComponent: () =>
                    import(
                        './discovery-standalone/discovery-standalone.component'
                    ).then((m) => m.DiscoveryStandaloneComponent),
            },
            {
                path: 'outputs',
                loadComponent: () =>
                    import(
                        './discovery-standalone/discovery-standalone.component'
                    ).then((m) => m.DiscoveryStandaloneComponent),
            },
            {
                path: 'projects',
                loadComponent: () =>
                    import(
                        './discovery-standalone/discovery-standalone.component'
                    ).then((m) => m.DiscoveryStandaloneComponent),
            },
            {
                path: 'collections/:collection-name/:collection-code',
                loadComponent: () =>
                    import(
                        './discovery-standalone/discovery-standalone.component'
                    ).then((m) => m.DiscoveryStandaloneComponent),
            },
            {
                path: 'collections/:collection-code',
                loadComponent: () =>
                    import(
                        './discovery-standalone/discovery-standalone.component'
                    ).then((m) => m.DiscoveryStandaloneComponent),
            },
            {
                path: '',
                redirectTo: 'outputs',
                pathMatch: 'full',
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DiscoveryRoutingModule {}
